import type { ReactNode } from 'react';

/**
 * v3 §5 Bausteine (line 213) — Hinweiskasten primitive.
 *
 * "Navy-Outline auf Weiß, 1.5 px. Nicht Gold, nicht Creme." The
 * existing `patterns/TipSection.tsx:28` has a golden border and is
 * NOT reused in the book flow (same line 143 of §3).
 *
 * v3 §5 line 213 verbatim class: `builder-field border-dream-navy p-4`
 * — "wörtlich der Fokus-Zustand der Utility, also volles Navy bei
 * 1.5 px auf Weiß".
 *
 * The `.builder-field` utility is defined in
 * `pwa/src/styles/index.css:183-195`. Its base class carries
 * `rounded-lg border-[1.5px] border-dream-navy/30 bg-white
 * transition-colors`; adding `border-dream-navy` overrides the
 * `/30` opacity to full navy, matching the focus state without a
 * focus event.
 *
 * Two variants live here — a `default` navy outline and an `error`
 * variant that swaps the border for the `error` token per v3 §3
 * line 151 ("Rot folgt dem Knopf"). Both keep the box shape
 * identical; only the border color changes.
 */

export interface HintBoxProps {
  readonly children: ReactNode;
  readonly variant?: 'default' | 'error';
  /** Optional class overrides for the caller. Passed after the base. */
  readonly className?: string;
}

export function HintBox({ children, variant = 'default', className }: HintBoxProps) {
  const borderClass = variant === 'error' ? 'border-error' : 'border-dream-navy';
  return (
    <div className={`builder-field ${borderClass} p-4${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}
